import React from 'react';

const COLORS = {
  green: 'var(--mm-green)',
  amber: 'var(--mm-yellow)',
  red: 'var(--mm-red)',
};

// Small colored LED-style dot for at-a-glance status (plant running/stopped,
// permit valid/expiring/expired, etc).
const StatusBulb = ({ status, style = {} }) => (
  <span
    style={{
      display: 'inline-block',
      width: '10px',
      height: '10px',
      borderRadius: '50%',
      backgroundColor: COLORS[status] || 'var(--mm-muted)',
      boxShadow: `0 0 6px ${COLORS[status] || 'transparent'}`,
      flexShrink: 0,
      ...style,
    }}
  />
);

export default StatusBulb;
